import React from 'react';
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';

import { FaLinkedin, FaGlobe, FaEnvelope } from 'react-icons/fa';

import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import Button from '../../components/CustomButtons/Button';
import { Card } from '../../components/Card';
import { CardBody } from '../../components/Card';
import { CardFooter } from '../../components/Card';

import Image from 'gatsby-image';

import teamStyle from '../../assets/jss/material-kit-react/views/landingPageSections/teamStyle';

class TeamSection extends React.Component {
  render() {
    const { classes, people=[], alumni=[], photos=[] } = this.props;
    const imageClasses = classNames(
      classes.imgRaised,
      classes.imgRoundedCircle,
      classes.imgFluid
    );

    /**
     * Finds and renders the image, uses blank person if no image match found.
     * @param fileAbsolutePath Absolute file path of the .md file.
     * @param name String name of person the image belongs to.
     * @return JSX for the image render.
     */
    function findAndRenderImage(fileAbsolutePath, name) {
      // String matching function
      const matchFunc = (str1, str2) => (str1 === str2);

      let file = fileAbsolutePath.split('/'); // full filename path
      file = file[file.length - 1]; // remove beginning path to just get "example.md"
      const fileName = file.substring(0, file.length - 3); // remove trailing .md

      // Find image that matches fileName
      const fluid = photos.find(photo => matchFunc(photo.node.fluid.originalName.split('.')[0], fileName));

      if (fluid) {
        return (
          <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
            <Image fluid={fluid.node.fluid} alt={name} className={imageClasses} loading='eager' fadeIn={false} />
          </GridItem>
        );
      } else { // return blank person
        const blankFluid = photos.find(photo => (photo.node.fluid.originalName.split('.')[0] === '0blankPerson'));
        return (
          <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
            <Image fluid={blankFluid.node.fluid} alt={name} className={imageClasses} loading='eager' fadeIn={false} />
          </GridItem>
        );
      }
    }

    /**
     * Renders a single person's card in the team section format. 
     * @param node The node input that contains the data from the .md file
     * @param i Index counter
     * @returns JSX for one person's card in the team section format.
     */
    function renderTeam(node, i) {
      const { excerpt, fileAbsolutePath } = node;
      const { name, title, email, website, linkedin } = node.frontmatter;

      return (
        <GridItem xs={12} sm={12} md={4} key={i}>
          <Card plain={name === 'Zachary Pardos' ? false : true} className={classes.card}>
            { findAndRenderImage(fileAbsolutePath, name) }
            <h4 className={classes.cardTitle}>
              {name}
              <br />
              <small className={classes.smallTitle}>{title}</small>
            </h4>
            <CardBody>
              <p className={classes.description}>
                {excerpt}
              </p>
            </CardBody>
            <CardFooter className={classes.justifyCenter}>
              {
                linkedin ?
                <Button
                  justIcon
                  href={linkedin}
                  target='_blank'
                  color='transparent'
                  className={classes.margin5}
                >
                  <FaLinkedin/>
                </Button>
                : null }
              {
                email ?
                <Button
                  justIcon
                  href={`mailto:${email}`}
                  color='transparent'
                  className={classes.margin5}
                >
                  <FaEnvelope/>
                </Button>
                : null
              }
              {
                website ?
                <Button
                  justIcon
                  href={website}
                  target='_blank'
                  color='transparent'
                  className={classes.margin5}
                >
                  <FaGlobe/>
                </Button>
                : null
              }
            </CardFooter>
          </Card>
        </GridItem>
      );
    }

    /**
     * Renders a single person's card in alumni section format. 
     * @param node The node input that contains the data from the .md file
     * @param i Index counter
     * @returns JSX for one person's card in alumni section format.
     */
    function renderAlumni(node, i) {
      const { fileAbsolutePath } = node;
      const { name, title } = node.frontmatter;

      return (
        <GridItem xs={12} sm={12} md={4} key={i}>
          <Card plain className={classes.card}>
            { findAndRenderImage(fileAbsolutePath, name) }
            <h4 className={classes.cardTitle}>
              { name }
              <br />
              <small className={classes.smallTitle}>{ title }</small>
            </h4>
          </Card>
        </GridItem>
      );
    }

    return (
      <div className={classes.section} id='team'>
        <h2 className={classes.headingTitle}>Meet the Team</h2>
        <div>
          <GridContainer>
            {
              people.map(({ node }, i) => {
                return renderTeam(node, i);
              })
            }
          </GridContainer>
        </div>

        <h3 className={classes.headingTitle}>Alumni</h3>
        <div>
        <GridContainer>
            {
              alumni.map(({ node }, i) => {
                return renderAlumni(node, i);
              })
            }
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(teamStyle)(TeamSection);
